import axios from "axios";

const formatUTCDate = (value) => {
  if (!value) return "N/A";

  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return value;

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const formatFaultDate = (value) => {
  if (!value) return "N/A";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "N/A";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
  { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
  { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 200, flex: 1 },
  { field: "tempDescarga", headerName: "Temp. Descarga", minWidth: 200, flex: 1 },
  { field: "tempAmbiente", headerName: "Temp. Ambiente", minWidth: 200, flex: 1 },
  { field: "presionSuccion", headerName: "Presión Succión", minWidth: 200, flex: 1 },
  { field: "presionDescarga", headerName: "Presión Descarga", minWidth: 200, flex: 1 },
  { field: "condicionActual", headerName: "Condición Actual", minWidth: 200, flex: 1 },
  { field: "porcentajeCarga", headerName: "Porcentaje Carga", minWidth: 200, flex: 1 },
  { field: "controlCarga", headerName: "Control de Carga", minWidth: 200, flex: 1 },
  { field: "remoteStart", headerName: "Remote Start", minWidth: 200, flex: 1 },
  { field: "remoteStop", headerName: "Remote Stop", minWidth: 200, flex: 1 },
  { field: "flowSwitchCooler", headerName: "Flow Switch (Cooler)", minWidth: 200, flex: 1 },
  { field: "powerProtection", headerName: "Power Protection (Protector de Fases)", minWidth: 250, flex: 1 },
  { field: "highPressureProtection", headerName: "High Pressure Protection", minWidth: 200, flex: 1 },
  { field: "lowPressureProtection", headerName: "Low Pressure Protection", minWidth: 200, flex: 1 },
  { field: "internalSwitch", headerName: "Internal Switch (Kriwan)", minWidth: 200, flex: 1 },
  { field: "contactorReaction", headerName: "Contactor Reaction (Interlock)", minWidth: 250, flex: 1 },
  { field: "oilLevelSwitch", headerName: "Oil Level Switch", minWidth: 200, flex: 1 },
  { field: "compressorOverloadProtection", headerName: "Compressor Overload Protection (GMRP)", minWidth: 300, flex: 1 },
  { field: "fanOverloadProtection", headerName: "Fan Overload Protection", minWidth: 200, flex: 1 },
  { field: "exvProtection", headerName: "EXV Protection", minWidth: 200, flex: 1 },
  { field: "input12", headerName: "Input 12", minWidth: 150, flex: 1 },
  { field: "input13", headerName: "Input 13", minWidth: 150, flex: 1 },
  { field: "input14", headerName: "Input 14", minWidth: 150, flex: 1 },
  { field: "input15", headerName: "Input 15", minWidth: 150, flex: 1 },
  { field: "mainContactor", headerName: "Main Contactor", minWidth: 200, flex: 1 },
  { field: "yContactor", headerName: "Y- Contactor", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvulaY1", headerName: "Load/Unload Válvula Y1", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvulaY2", headerName: "Load/Unload Válvula Y2", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvulaY3", headerName: "Load/Unload Válvula Y3", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvulaY4", headerName: "Load/Unload Válvula Y4", minWidth: 200, flex: 1 },
  { field: "middleSprayValve", headerName: "Middle Spray Valve", minWidth: 200, flex: 1 },
  { field: "tailSprayValve", headerName: "Tail Spray Valve", minWidth: 200, flex: 1 },
  { field: "overCoolerSolenoidValve", headerName: "Over Cooler Solenoid Valve", minWidth: 250, flex: 1 },
  { field: "alarm", headerName: "Alarm", minWidth: 150, flex: 1 },
  { field: "pumpRun", headerName: "Pump Run", minWidth: 200, flex: 1 },
  { field: "output11", headerName: "Output 11", minWidth: 200, flex: 1 },
  { field: "output12", headerName: "Output 12", minWidth: 200, flex: 1 },
  { field: "output13", headerName: "Output 13", minWidth: 200, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha de Falla 1", minWidth: 200, flex: 1 },
  { field: "numeroFalla1", headerName: "Número de Falla 1", minWidth: 300, flex: 1 },
  { field: "fechaFalla2", headerName: "Fecha de Falla 2", minWidth: 200, flex: 1 },
  { field: "numeroFalla2", headerName: "Número de Falla 2", minWidth: 300, flex: 1 },
  { field: "fechaFalla3", headerName: "Fecha de Falla 3", minWidth: 200, flex: 1 },
  { field: "numeroFalla3", headerName: "Número de Falla 3", minWidth: 300, flex: 1 },
  { field: "fechaFalla4", headerName: "Fecha de Falla 4", minWidth: 200, flex: 1 },
  { field: "numeroFalla4", headerName: "Número de Falla 4", minWidth: 300, flex: 1 },
  { field: "fechaFalla5", headerName: "Fecha de Falla 5", minWidth: 200, flex: 1 },
  { field: "numeroFalla5", headerName: "Número de Falla 5", minWidth: 300, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempProcesoEntrada: row["Temp Proceso Entrada"],
  tempProcesoSalida: row["Temp Proceso Salida"],
  tempDescarga: row["Temp Descarga"],
  tempAmbiente: row["Temp Ambiente"],
  presionSuccion: row["Presion Succion"],
  presionDescarga: row["Presion Descarga"],
  condicionActual: row["Condicion Actual"],
  porcentajeCarga: row["Porcentaje Carga"],
  controlCarga: row["Control de Carga"],
  remoteStart: row["Remote Start"],
  remoteStop: row["Remote Stop"],
  flowSwitchCooler: row["Flow Switch (Cooler)"],
  powerProtection: row["Power Protection (Protector de Fases)"],
  highPressureProtection: row["High Pressure Protection"],
  lowPressureProtection: row["Low Pressure Protection"],
  internalSwitch: row["Internal Switch (Kriwan)"],
  contactorReaction: row["Contactor Reaction (Interlock)"],
  oilLevelSwitch: row["Oil Level Switch"],
  compressorOverloadProtection: row["Compressor Overload Protection (GMRP)"],
  fanOverloadProtection: row["Fan Overload Protection"],
  exvProtection: row["EXV Protection"],
  input12: row["Input_12"],
  input13: row["Input_13"],
  input14: row["Input_14"],
  input15: row["Input_15"],
  mainContactor: row["Main Contactor"],
  yContactor: row["Y- Contactor"],
  loadUnloadValvulaY1: row["Load/Unload Valvula Y1"],
  loadUnloadValvulaY2: row["Load/Unload Valvula Y2"],
  loadUnloadValvulaY3: row["Load/Unload Valvula Y3"],
  loadUnloadValvulaY4: row["Load/Unload Valvula Y4"],
  middleSprayValve: row["Middle Spray Valve"],
  tailSprayValve: row["Tail Spray Valve"],
  overCoolerSolenoidValve: row["Over Cooler Solenoid Valve"],
  alarm: row["Alarm"],
  pumpRun: row["Pump Run"],
  output11: row["Output_11"],
  output12: row["Output_12"],
  output13: row["Output_13"],
  fechaFalla1: formatFaultDate(row["Fecha de Falla 1"]),
  numeroFalla1: row["Numero de Falla 1"] || "N/A",
  fechaFalla2: formatFaultDate(row["Fecha de Falla 2"]),
  numeroFalla2: row["Numero de Falla 2"] || "N/A",
  fechaFalla3: formatFaultDate(row["Fecha de Falla 3"]),
  numeroFalla3: row["Numero de Falla 3"] || "N/A",
  fechaFalla4: formatFaultDate(row["Fecha de Falla 4"]),
  numeroFalla4: row["Numero de Falla 4"] || "N/A",
  fechaFalla5: formatFaultDate(row["Fecha de Falla 5"]),
  numeroFalla5: row["Numero de Falla 5"] || "N/A",
});

const fetchRows = async ({ endpoint, idEquipo, fechaInicio, fechaFinal }) => {
  const limit = 1000;
  let offset = 0;
  let allData = [];
  let total = null;

  while (total === null || offset < total) {
    const response = await axios.post(
      endpoint,
      {
        idEquipo,
        fechaInicio,
        fechaFinal,
        limit,
        offset,
      },
      { headers: { "Content-Type": "application/json" } }
    );

    const parsedBody = response.data?.body
      ? typeof response.data.body === "string"
        ? JSON.parse(response.data.body)
        : response.data.body
      : response.data;

    if (!parsedBody.success) {
      throw new Error(parsedBody.message || "La consulta no fue exitosa.");
    }

    let pageData = parsedBody.data || [];

    if (
      Array.isArray(pageData) &&
      pageData.length > 0 &&
      Array.isArray(pageData[0])
    ) {
      pageData = pageData[0];
    }

    if (!Array.isArray(pageData)) {
      throw new Error("La API no regresó los datos en formato de tabla.");
    }

    pageData = pageData.filter(Boolean);

    allData = [...allData, ...pageData];

    total = parsedBody.pagination?.total || pageData.length;

    offset += limit;

    if (pageData.length === 0) break;
  }

  return allData;
};

export const victex1CompresorConsultaConfig = {
  title: "Victex 1 Compresor",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/victex1compresor/datos",
  columns,
  mapRow,
  fetchRows,
};